import CardDataComponent from "@/pages/components/card-data/CardDataComponent.vue";
import { Tab } from "./tab";

const CARD_DATA_TAB_CHANGED = "cad-data-tab-changed-event";

export { Tab, CARD_DATA_TAB_CHANGED, CardDataComponent as default };
